import { render, staticRenderFns } from "./cov-summary.vue?vue&type=template&id=6f1a1a10&scoped=true&"
import script from "./cov-summary.vue?vue&type=script&lang=js&"
export * from "./cov-summary.vue?vue&type=script&lang=js&"
import style0 from "./cov-summary.vue?vue&type=style&index=0&id=6f1a1a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a1a10",
  null
  
)

export default component.exports